import $ from 'jquery';
import angular from 'angular';
import { AppModule } from './components/app';
import { mountFooter } from './footer-mount';
import { track, ERROR } from '@updater-core/lib/tracker';

window.jQuery = $;

angular.module(AppModule.name).config(function ($urlMatcherFactoryProvider) {
  'ngInject';

  // HACK ALERT! MONKEY PATCHING ui-router internal prototype.
  // ui-router will URL-encode forward-slashes in our `/*path` param catch all,
  // wrecking routes within the micro apps.
  // Angular has only very recently (1.6.7) been patched for this
  // behavior, but legacy ui-router still URL-encodes all params.
  // https://github.com/angular-ui/ui-router/issues/2598#issuecomment-376300695
  const proto = Object.getPrototypeOf($urlMatcherFactoryProvider.compile(''));
  const { format } = proto;
  proto.format = function (...args) {
    return format.apply(this, args).replace(/~2F/g, '/');
  };
});

angular.module(AppModule.name).run((updStore, $rootScope) => {
  'ngInject';
  $rootScope.$on('$destroy', mountFooter(updStore).destroy);
});

angular.module(AppModule.name).provider('appShell', function () {
  this.interactors = {};

  class AppShellService {
    constructor(interactors) {
      this._interactors = interactors;
    }

    get interactors() {
      return this._interactors;
    }

    isAnAppShellRoute(url) {
      try {
        const pathToSearchFor = new URL(url).pathname;
        const router = this._interactors.router;
        // look at every path the parent router handles BUT the last one which is
        // the catch all for the angular app
        return Boolean(
          router.paths
            .slice(0, -1)
            .find((path) => pathToSearchFor.match(new RegExp(path)))
        );
      } catch (ex) {
        track({
          domain: 'mover',
          object: 'app_shell_route',
          verb: ERROR,
          details: {
            message: ex.message,
            stack: ex.stack,
            ...ex,
          },
        });
        return false;
      }
    }
  }

  this.$get = () => new AppShellService(this.interactors);
});

export { angular, AppModule };
